// Sometimes I use external network interface like `192.168.1.102` here
// E.g. - when debugging on my phone, or via VMWare MacOS machine.
import { urlConfig } from "./utils";

export const localhost = "localhost";
export const converstationHistoryKey = "messagesHistory";
export const teaserShownTimesKey = "teaserShownTimes";
export const leadIDKey = "leadID";
export const UUIDKey = "UUID";
export const teaserClosedKey = "teaserClosed";
export const nextPageUrlKey = "nextPageUrl";
export const savedStateKey = "savedState";
/**
 * Used to substitute user's first name in the messages history saved in the local storage, because we don't store the messages text itself.
 */
export const savedUserFirstNameKey = "firstName";

export const ScreenSize = {
  mobile: 768,
  smallMobile: 321,
};

export const device = {
  mobile: `(max-width: ${ScreenSize.mobile}px)`,
  smallMobile: `(max-width: ${ScreenSize.smallMobile}px)`,
  landscape: "(orientation: landscape) and (max-height: 450px)",
};

/**
 * Not the same as user agent check. But requires refactoring.
 */
export const isNarrowScreen = window.innerWidth <= ScreenSize.mobile;
export const isVeryNarrowScreen = window.innerWidth <= ScreenSize.smallMobile;

export const phoneErrorMessage = `
  Sorry but that is an invalid phone number. Please check it is 10
  digits long and does not contain letters or symbols.`;

export const maxPhoneErrorMessage = `
Hmm, seems like you really don't want to enter in a phone number. We can take you through to the next step, 
but pricing is subject to change, and we won't be able to reference this quote. Are you sure you would like to continue?`;

export const nameErrorMessage = `
  Can you please enter your full name? Our system requires first and last name.`;

export const contactInformationMessage = `
  By entering in your contact information you agree to be contacted by telephone.
  You also consent that we, may reach out to you using a system that can auto-dial and send SMS;
  however, you do not need to consent to this to use our service.
`;

export const typingDuration = 1500;
export const typingIADuration = typingDuration * 1.5 * (urlConfig?.noAnimation ? 0 : 1);

export const defaultErrorMessage = "Something went wrong and we couldn't process your request. Sorry about that!";
export const financialChatActivated =
  (window.financialChatActivated || urlConfig?.financialChatActivated) && !isNarrowScreen;
